import React from 'react';
import { motion } from 'framer-motion';

const ReadyMade = () => {
  return (
    <section className="bg-svnate-darkNavy py-24 px-6 md:px-12 relative" id="ready-made">
      <div className="container mx-auto relative z-10 max-w-5xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex flex-col md:flex-row items-center justify-between p-8 md:p-12 rounded-2xl bg-[#0f1419] border border-white/10  relative overflow-hidden"
        >
          {/* Subtle gradient glow in background */}
          <div className="absolute inset-0 bg-gradient-to-r from-svnate-blue/20 to-transparent pointer-events-none"></div>
          
          <div className="mb-8 md:mb-0 md:mr-8 relative z-10 text-center md:text-left">
            <h3 className="text-3xl font-bold text-white mb-3">Need something custom?</h3>
            <p className="text-foreground/70 text-lg">
              We can build it from scratch tailored to your exact specifications.
            </p>
          </div>
          
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="relative z-10 w-full md:w-auto px-8 py-4 bg-white text-black rounded-full font-medium hover:scale-105 transition-transform duration-300 shadow-[0_0_20px_rgba(255,255,255,0.2)] hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] whitespace-nowrap"
          >
            Request Custom Solution
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default ReadyMade;
